<template>
  <div class="common-progress-component">
    <div class="progress-line" ref="line"></div>
  </div>
</template>

<script>
export default {
  name: 'commonProgress',
  props: {
    rate: {
      type: [String, Number],
      default: 0,
    },
  },
  mounted() {
    this.$refs.line.style.width = `${this.rate}%`;
  },
  watch: {
    rate() {
      this.$refs.line.style.width = `${this.rate}%`;
    },
  },
};
</script>

<style scoped lang="scss">
.common-progress-component{
  display: flex;
  align-items: center;
  width: 187px;
  height: 14px;
  background: #FFF;
  border: 2px solid rgba(255, 255, 255, 0.53);
  border-radius: 11px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.11);
  opacity: 0.9;

  .progress-line{
    height: 11px;
    background: #FF6002;
    border-radius: 7px 0 0 7px;
    box-shadow: 0 0 2px 0 rgba(255,255,255,0.5);
    opacity: 0.9;
  }
}
</style>
